<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 0px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-form-dropdown</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.dropdownButton') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <!-- <template v-if="$vuetify.breakpoint.mdAndUp">        
        <v-btn-toggle
          v-model="textAlign" 
          @change="handleChangeIsModified"
        >
          <v-btn :value="1" @click="content.Style.TextAlign = 'left'" text>
            <v-icon>mdi-format-align-left</v-icon>
          </v-btn>
          <v-btn :value="2" @click="content.Style.TextAlign = 'center'" text>
            <v-icon>mdi-format-align-center</v-icon>
          </v-btn>
          <v-btn :value="3" @click="content.Style.TextAlign = 'right'" text>
            <v-icon>mdi-format-align-right</v-icon>
          </v-btn>
          <v-btn :value="4" @click="content.Style.TextAlign = 'justify'" text>
            <v-icon>mdi-format-align-justify</v-icon>
          </v-btn>
        </v-btn-toggle>
        <v-btn-toggle
          v-model="style"
          multiple
          @change="handleChangeIsModified"
        >
          <v-btn @click="content.Style.SizeMult = content.Style.SizeMult  + 1" text>
            <v-icon>mdi-format-font-size-increase</v-icon>
          </v-btn>
          <v-btn @click="content.Style.SizeMult = content.Style.SizeMult  - 1" text>
            <v-icon>mdi-format-font-size-decrease</v-icon>
          </v-btn>
          <v-btn @click="content.Style.ToUpperCase = !content.Style.ToUpperCase" text>
            <v-icon>mdi-format-letter-case-upper</v-icon>
          </v-btn>
        </v-btn-toggle>
        <custom-color-picker
          v-if="TextColor"
          :width="'50px !important'"
          :height="'47px'"
          :icon="'mdi-format-color-text'"
          :color="TextColor"
          :onChangeColor="handleChangeColor"
        />
      </template> -->
    </v-toolbar>    
    <v-layout wrap v-show="!collapseContent">
      <v-flex xs12>
        <translate
          v-model="content.DropdownButtonTitle"
          :languages="languages"
          :label="$t('menuType.text')"
          @input="handleChangeIsModified"
          style="padding: 0 10px 0 10px;"
        />
      </v-flex>
      <v-flex xs3>
        <div
          class="text-left"
          style="margin-top: 10px"
        >
          {{ $t('dropdownButton.colors') }}
        </div>
      </v-flex>
      <v-flex xs9>
        <custom-color-picker-background-and-text
          style="width: 100px;"
          :BGColor="content.DropdownButtonBGColor"
          :TextColor="content.DropdownButtonTextColor"
          :onChangeColor="handleChangeCustomMenuColor"
        />
      </v-flex>
      <v-flex xs12>
        11111
        <!-- <form-content-item
          class="list-group-item"
          v-for="(content, index) in contents"
          :key="`content${index}`"
          :content="content"
          :onMoveDisabled="handleMoveDisabled"
          :isMoveContent="isMoveContent"
          :scrollPosition="scrollPosition"
        /> -->
      </v-flex>
      <!-- <v-flex xs12 style="padding-top: 20px;">
        <component-in-line :menuID="content.ID" />
      </v-flex> -->
    </v-layout>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import Translate from '@/components/Translate'
  // import FormContentItem from './FormContentItem'
  import CustomColorPickerBackgroundAndText from '@/components/CustomColorPickerBGAndText'
   import ComponentInLine from '../../ComponentInLine'
  export default {
    components: {
      Translate,
      CustomColorPickerBackgroundAndText,
      ComponentInLine,
      // FormContentItem
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    data: () => ({
    }),
    computed: {
      ...mapState('app',['collapseContent', 'ColorContent']),
      languages () {
        return this.$store.state.app.Languages
      },
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    methods: {
      handleChangeIsModified () {
      },
      handleChangeCustomMenuColor (BGColor, TextColor) {
        this.content.DropdownButtonBGColor = BGColor
        this.content.DropdownButtonTextColor = TextColor
        this.handleChangeIsModified()
      },
      handleAddContent (){
      },
      handleMoveDisabled (value) {
        this.moveDisabled = value
      }
    }
  }
</script>

<style scoped>
</style>

